import { render } from "./selectEstatesModal.vue?vue&type=template&id=fe8671e0&scoped=true&ts=true"
import script from "./selectEstatesModal.vue?vue&type=script&lang=ts"
export * from "./selectEstatesModal.vue?vue&type=script&lang=ts"

import "./selectEstatesModal.vue?vue&type=style&index=0&id=fe8671e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8671e0"]])

export default __exports__